import * as React from "react";
import { WizardHotelPWA } from "./WizardHotelPWA";
import { WizardHotelPWAExpando } from "./views/WizardHotelPWAExpando";
import { WizardHotelPWAProps } from "./typings";
import { withStores } from "stores";

export const WizardHotelPWAViews = withStores(
  "analytics",
  "routeStore",
  "context",
  "cookies",
  "compositionStore",
  "wizardState"
)((props: WizardHotelPWAProps) => {
  if (props.flexComponent.model.view === "expando") {
    return <WizardHotelPWAExpando {...props} />;
  }

  return <WizardHotelPWA {...props} />;
});

export default WizardHotelPWAViews;
